export class AuthErrorConstants {
    public static readonly passwordResetCode = 'AADB2C90118';

    public static readonly interactionRequiredCodes = new Set([
        'interaction_required',
        'login_required',
        'consent_required',
        'no_tokens_found',
        'token_refresh_required',
    ]);
}